import styles from "./styles/addons_modal_style.module.css";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../../../di/di";
import { useEffect, useState, useRef } from "react";
import { availAddons, getActiveAddons } from "../state/profile_slice";
import AddonSocketServiceImpl from "../../../../data/service/impl/addon_socket_service_impl";
import Confetti from 'react-confetti';
import { Check, X } from "lucide-react";
import { PaymentRoute } from "../../../../../core/routes/route_constants";
import { useNavigate } from "react-router-dom";

const AddonsModalComponent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.profile.user);
  const showAddonsModal = useSelector((state) => state.profile.showAddonsModal);
  const setAddonsModalOpen = (value) => dispatch(profileActions.setShowAddonsModal(value));
  const isFetchingAddons = useSelector((state) => state.profile.isFetchingAddons);
  const addons = useSelector((state) => state.profile.addOns);
  const [hoveredPlan, setHoveredPlan] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const isPurchaseShowToast = useSelector((state) => state.profile.isPurchaseShowToast);
  const addOnPurchageURL = useSelector((state) => state.profile.addOnPurchageURL);
  const addonSocketService = new AddonSocketServiceImpl();
  const toastTimeoutRef = useRef(null);
  const isAddonsPurchasing = useSelector(state => state.profile.isAddonsPurchasing);
  const currentAddonPurchasingID = useSelector(state => state.profile.currentAddonPurchasingID);
  const isPurchasingAddonSuccess = useSelector(state => state.profile.isPurchasingAddonSuccess);

  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 0,
    height: typeof window !== 'undefined' ? window.innerHeight : 0,
  });

  useEffect(() => {
    console.log(isPurchasingAddonSuccess, 'isPurchasingAddonSuccess')
  }, [isPurchasingAddonSuccess])
  const handlePurchaseAddon = async (addon) => {
    // setIsLoading(true);
    // console.log("ADD ON", addon);

    // // Connect socket if not already connected
    // if (!addonSocketService.addonSocket) {
    //   addonSocketService.connect();

    //   // Wait for socket to connect
    //   await new Promise((resolve) => {
    //     addonSocketService.addonSocket?.on("connect", (socketId) => {
    //       resolve(socketId);
    //     });
    //   });
    // }

    // const socketId = addonSocketService.getSocketId();
    // console.log("Socket ID:", socketId);
    // dispatch(profileActions.setCurrentAddonPurchasingID(addon._id));
    // dispatch(
    //   availAddons({
    //     userId: user._id,
    //     addOnId: addon._id,
    //     socketId: socketId,
    //   })
    // );

    navigate(`${PaymentRoute}/addon/${addon._id}`);
  };

  useEffect(() => {
    if (showAddonsModal) {
      dispatch(getActiveAddons());
      addonSocketService.connect();

      // Listen for addon purchase events
      addonSocketService.addonSocket?.on("paymentEvent", (data) => {
        console.log("qamote", data);
        // Always reset loading state
        setIsLoading(false);
        console.log(data.data.status);
        if (data.data.status === "APPROVED" || data.data.status === 'success') {
          dispatch(profileActions.showPurchaseToast(true));
          dispatch(profileActions.setIsToRefreshData(true));
          dispatch(profileActions.setPurchaseSuccess(true))

          // Clear any existing timeout
          if (toastTimeoutRef.current) {
            clearTimeout(toastTimeoutRef.current);
          }

          // Set new timeout for toast and modal close
          toastTimeoutRef.current = setTimeout(() => {
            dispatch(profileActions.showPurchaseToast(false));
            dispatch(profileActions.setShowAddonsModal(false));
            dispatch(profileActions.setPurchaseSuccess(false));
            addonSocketService.disconnect();
          }, 3000);
        } else if (data.data.status === "FAILED" || data.data.status === "CANCELLED") {
          // Handle failure case - could add error toast here if needed
          dispatch(profileActions.setShowErrorToast(true));
          dispatch(profileActions.setErrorToastMessage("Purchase failed. Please try again."));
        }
      });

      // Handle socket disconnection or errors
      addonSocketService.addonSocket?.on("disconnect", () => {
        setIsLoading(false);
      });

      addonSocketService.addonSocket?.on("error", () => {
        setIsLoading(false);
      });

      return () => {
        setIsLoading(false); // Reset loading state on cleanup
        addonSocketService.disconnect();
        // Clear timeout on cleanup
        if (toastTimeoutRef.current) {
          clearTimeout(toastTimeoutRef.current);
        }
      };
    }
  }, [showAddonsModal, dispatch]);

  useEffect(() => {
    if (addOnPurchageURL) {
      window.open(addOnPurchageURL, "_blank");
      dispatch(profileActions.resetAddonPurchaseURL());
    }
  }, [addOnPurchageURL, dispatch]);

  // Additional useEffect to handle toast timing independently
  useEffect(() => {
    if (isPurchaseShowToast) {
      // Clear any existing timeout
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }

      // Set new timeout for toast
      toastTimeoutRef.current = setTimeout(() => {
        dispatch(profileActions.showPurchaseToast(false));
      }, 3000);
    }

    return () => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
    };
  }, [isPurchaseShowToast, dispatch]);

  if (!showAddonsModal) return null;

  return (
    <div className="fixed lg:ml-[15rem] inset-0 flex flex-col items-center justify-center bg-black bg-opacity-70 p-5 md:p-0">
      {isPurchasingAddonSuccess ? (
        <Confetti
          numberOfPieces={250}
          recycle={false}
          colors={["#dc2626", "#b91c1c", "#7f1d1d", "#991b1b", "#f87171"]}
          style={{ position: "fixed", top: 0, left: 0, pointerEvents: "none" }}
        />
      ) : null}

      <div
        className="w-full h-full md:w-[45rem] md:h-[44rem] 
        flex flex-col 
        items-center
        overflow-y-auto
                    
                    bg-gradient-to-b from-slate-950/90 to-fuchsia-950/80 backdrop-blur-md 
                    rounded-xl 
                    overflow-hidden 
                    shadow-2xl 
                    relative 
                    border border-red-900/20 
                    animate-scale-in"
      >
        <button onClick={() => setAddonsModalOpen(false)} className="absolute top-4 right-4 text-white/70 hover:text-white active:translate-y-0.5 active:shadow-none">
          <X size={24} />
        </button>

        <h1 className="text-3xl font-light text-center mb-8 text-white mt-8">
          Video Chat <span className="font-semibold">Add-ons</span>
        </h1>

        {/* Success message overlay */}
        {isPurchaseShowToast && (
          <div className="absolute inset-0 flex items-center justify-center bg-slate-950/90 z-10 animate-fade-in-scale">
            <div className="text-center p-8">
              <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Check size={32} className="text-green-500" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-2">Purchase Successful!</h3>
              {/* <p className="text-pink-300 mb-1">{purchasedPlan?.name}</p>
                            <p className="text-pink-300 text-xl font-semibold">{purchasedPlan?.price}</p> */}
              {/* <p className="text-pink-300/70 text-sm mt-4">Your additional video chat time will be available immediately.</p> */}
            </div>
          </div>
        )}

        <div className="w-[calc(100%-3rem)] md:h-[35rem] relative">
          {isFetchingAddons && addons.length === 0 && (
            <div className="absolute flex items-center justify-center w-full h-full ">
              <div className="animate-spin rounded-full h-12 w-12 border-4 border-red-900 border-t-pink-500 mb-10"></div>
            </div>
          )}

          <div className="absolute grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 w-full h-full">
            {addons.map((addon, index) => (
              <div key={addon._id} className="h-full" style={{ animationDelay: `${index * 0.1}s` }}>
                <div
                  className={`h-full relative bg-slate-900/70 backdrop-blur-sm rounded-lg overflow-hidden transition-all duration-300 hover-parent
                                    ${hoveredPlan === addon.key ? "shadow-[0_0_25px_rgba(185,28,28,0.35)]" : "shadow-lg"}
                                    ${addon.key === "ultimate" ? "ring-2 ring-red-900/50" : ""}`}
                  onMouseEnter={() => setHoveredPlan(addon.key)}
                  onMouseLeave={() => setHoveredPlan(null)}
                >
                  {addon.key === "ultimate" && (
                    <div className="absolute top-4 right-4 z-10">
                      <div className="bg-gradient-to-r from-red-800 via-red-900 to-red-950 px-3 py-0.5 text-xs uppercase tracking-wider text-white rounded-full font-medium">
                        Premium
                      </div>
                    </div>
                  )}

                  <div className="p-8 flex flex-col h-full">
                    <h2
                      className={`text-xl font-semibold mb-1 
                                        ${addon.key === "ultimate" ? "text-pink-300" : "text-white"}`}
                    >
                      {addon.name}
                    </h2>

                    <p className="text-pink-300/70 text-sm mb-6">{addon.description}</p>

                    <div className="mb-8 flex-grow flex items-center justify-center">
                      <span
                        className={`text-4xl font-light 
                                            ${addon.key === "ultimate" ? "text-pink-300" : "text-white"}`}
                      >
                        $ {addon.price.$numberDecimal}
                      </span>
                    </div>

                    <button
                      disabled={isAddonsPurchasing}

                      className={`py-3 w-full rounded-full text-white font-medium tracking-wide
                                            ${addon.key === "ultimate"
                          ? "bg-gradient-to-r from-red-800 via-red-900 to-red-950 shadow-lg shadow-red-900/20 hover-lift-premium"
                          : "bg-slate-800/60 hover:bg-slate-700/70 border border-red-900/20 hover-lift" 
                        }
                                            transition-all duration-300`}
                      onClick={() => handlePurchaseAddon(addon)}
                    >
                      {!isAddonsPurchasing ? 'Purchase' : (addon._id == currentAddonPurchasingID ? 'Purchasing...' : 'Purchase')}
                    </button>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-b from-red-600/5 to-transparent pointer-events-none hover-overlay" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles.modal_overlay}>
      <div className={styles.addons_modal}>
        <button onClick={() => !isLoading && dispatch(profileActions.setShowAddonsModal(false))} className={styles.close_button} disabled={isLoading}>
          <svg xmlns="http://www.w3.org/2000/svg" className={styles.close_icon} viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>

        <h1 className={styles.addons_title}>
          Video Chat <span>Add-ons</span>
        </h1>

        {/* Success message overlay */}
        {isPurchaseShowToast && (
          <div className={styles.success_overlay}>
            <div className={styles.success_content}>
              <div className={styles.success_icon}>
                <svg className={styles.check_icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              </div>
              <h3 className={styles.success_title}>Purchase Successful!</h3>
              <p className={styles.success_message}>Your additional video chat time will be available immediately.</p>
            </div>
          </div>
        )}

        <div className={styles.addons_grid}>
          {addons.map((addon, index) => (
            <div
              key={addon._id}
              className={styles.addon_card_wrapper}
              style={{
                animationDelay: `${index * 0.1}s`,
              }}
            >
              <div
                className={`${styles.addon_card} ${hoveredPlan === addon._id ? styles.addon_card_hovered : ""} ${addon._id === "ultimate" ? styles.addon_card_ultimate : ""
                  }`}
                onMouseEnter={() => setHoveredPlan(addon._id)}
                onMouseLeave={() => setHoveredPlan(null)}
              >
                {addon._id === "ultimate" && <div className={styles.premium_badge}>Premium</div>}

                <div className={styles.addon_content}>
                  <h2 className={`${styles.addon_name} ${addon._id === "ultimate" ? styles.addon_name_ultimate : ""}`}>{addon.name}</h2>

                  <p className={styles.addon_duration}>{addon.description}</p>

                  <div className={styles.addon_price_wrapper}>
                    <span className={`${styles.addon_price} ${addon._id === "ultimate" ? styles.addon_price_ultimate : ""}`}>
                      {addon.price.$numberDecimal}
                    </span>
                  </div>

                  <button
                    className={`${styles.purchase_button} ${addon._id === "ultimate" ? styles.purchase_button_ultimate : ""}`}
                    onClick={() => handlePurchaseAddon(addon)}
                    disabled={isLoading}
                  >
                    {isLoading ? "Processing..." : "Purchase"}
                  </button>
                </div>

                <div className={`${styles.addon_hover_overlay} ${hoveredPlan === addon._id ? styles.addon_hover_overlay_visible : ""}`} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AddonsModalComponent;
